<template>
  <div id="app">
    <MiniViewer />
  </div>
</template>

<script>
import MiniViewer from "./components/MiniViewer.vue";

export default {
  name: "app",
  components: {
    MiniViewer
  }
};
</script>

<style></style>
